/* eslint-disable react/no-array-index-key */
/* eslint-disable import/no-duplicates */
import React,
{
  CSSProperties, FunctionComponent, useEffect, useState,
} from 'react';
import Snowfall from 'react-snowfall';
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectCoverflow } from 'swiper';

import PublicLayout from '../../layout/PublicLayout';
import t from '../../text-strings';
import Image from '../../components/Image';
import images from '../../assets/images';
import Accordion from '../../components/Accordion';
import 'swiper/swiper.min.css';
import { useStoreActions } from '../../store/hooks';

const ChristmasContest: FunctionComponent = () => {
  const {
    get_photos,
  } = useStoreActions((actions) => actions.christmas);
  const [photos, set_photos] = useState<Record<string, string>>({});
  const [modalOpen, setModalOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState<string | undefined>(undefined);
  const [currentTitle, setCurrentTitle] = useState<string | undefined>(undefined);

  const openModal = (name: string, src: string) => {
    setCurrentImage(src);
    setCurrentTitle(name);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setCurrentImage(undefined);
    setCurrentTitle(undefined);
  };

  const noPadding = {
    padding: '0px',
    background: '#130e1e',
  };
  const noPaddingHeader = {
    padding: '0px',
    background: 'white',
    paddingTop: '2rem',
    // background: 'linear-gradient(180deg, rgba(255,255,255,1)
    // 0%, rgba(255,255,255,1) 83.5%, rgba(19,14,30,1) 83.5%)',
  };
  const titulo = {
    textAlign: 'center',
  } as CSSProperties;

  const justified = {
    textAlign: 'justify',
  } as CSSProperties;

  const modalCSS = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
  } as CSSProperties;

  const modalContentCSS = {
    position: 'relative',
    maxWidth: '90%',
    maxHeight: '90%',
  } as CSSProperties;

  const modalContentImg = {
    width: '100%',
    height: 'auto',
    maxHeight: '90vh',
    maxWidth: '90vw',
    borderRadius: '10px',
  } as CSSProperties;

  const closeBtn = {
    position: 'absolute',
    top: '10px',
    right: '10px',
    border: 'none',
    color: 'white',
    fontSize: '2rem',
    cursor: 'pointer',
    background: 'rgba(0,0,0,0.5)',
    borderRadius: '100%',
    display: 'flex',
    alignContent: 'center',
    alignItems: 'center',
    height: '28px',
    width: '28px',
    justifyContent: 'center',
    paddingTop: '5px',
  } as CSSProperties;

  useEffect(() => {
    get_photos({}).then(set_photos);
  }, []);

  return (
    <PublicLayout title={t('christmas.title')}>
      <Snowfall />
      <link
        href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap-grid.min.css"
        rel="stylesheet"
        crossOrigin="anonymous"
      />
      <div className="container-fluid" style={noPadding}>
        <div className="row justify-content-center">
          <div className="col-lg-8 col-md-10 col-12">
            <Image src={images.energiaNavidad} />
          </div>
        </div>
      </div>
      <div className="container-fluid" style={noPaddingHeader}>
        <div className="row justify-content-center">
          <div className="col-lg-8 col-md-10 col-12">
            <p>
              Tu pueblo es parte importante de nuestra historia, y es que desde hace más de 80 años,
              hacemos llegar la luz a tu colegio, a tu casa, al centro médico o incluso al campo de
              fútbol. &nbsp;
              <b>La energía que necesitas hoy.</b>
              <br />
              <br />
              Y ahora, gracias a tu dibujo, también la energía del mañana.
              <br />
              <br />
              ¡Gracias por participar!
              <br />
              <br />
            </p>
          </div>
          {Object.keys(photos)?.length && (
            <div className="col-lg-8 col-md-12">
              <h2 className="title-medium text-black mb-16">Nuestros participantes</h2>
              <Swiper
                effect="coverflow"
                grabCursor
                centeredSlides
                slidesPerView={2}
                coverflowEffect={{
                  rotate: 50, // Rotación de los slides
                  stretch: 0, // Espaciado entre los slides
                  depth: 100, // Profundidad del efecto
                  modifier: 1,
                  slideShadows: true, // Sombras para mayor efecto visual
                }} // Botones de paginación
                modules={[EffectCoverflow]}
                style={{ height: '540px' }}
              >
                {Object.keys(photos).map((i, k) => (
                  <SwiperSlide key={k} onClick={() => openModal(i, (photos as any)[i])}>
                    <div style={{
                      backgroundImage: `url('${(photos as any)[i]}')`, borderRadius: '10px', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)', height: '100%', backgroundRepeat: 'no-repeat', backgroundPosition: 'center', backgroundSize: 'cover', display: 'flex', flexDirection: 'column', justifyContent: 'end',
                    }}
                    >
                      <div style={{
                        backgroundColor: 'rgba(0,0,0,0.8)', color: 'white', padding: '1rem', borderBottomLeftRadius: '10px', borderBottomRightRadius: '10px',
                      }}
                      >
                        {decodeURI(i)}
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
              {modalOpen && (
              <div style={modalCSS} onClick={closeModal}>
                <div style={modalContentCSS} onClick={(e) => e.stopPropagation()}>
                  <img src={currentImage} alt="Foto ampliada" style={modalContentImg} />
                  <button type="button" style={closeBtn} onClick={closeModal}>
                    &times;
                  </button>
                  <div style={{
                    backgroundColor: 'rgba(0,0,0,0.8)', color: 'white', padding: '1rem', borderBottomLeftRadius: '10px', borderBottomRightRadius: '10px', position: 'relative', height: '50px', bottom: '50px', display: 'grid', alignItems: 'center',
                  }}
                  >
                    {decodeURI(currentTitle ?? '')}
                  </div>
                </div>
              </div>
              )}
            </div>
          )}
        </div>
      </div>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-6 col-md-8 col-12" id="bases-legales">
            <br />
            <br />
            <Accordion
              key="bases-legales"
              title="Bases para la participación"
              text={(
                <div style={justified}>
                  <h3 style={titulo}>
                    <b>BASES PARA LA PARTICIPACIÓN EN LA ACTIVIDAD</b>
                  </h3>
                  <h1 style={titulo}><b>“La energía de la Navidad”</b></h1>
                  <br />
                  <p>
                    Grupo Empresarial Cuerva, con domicilio social en Calle Nueva de
                    san Antón, 20 - PISO 5 A, y con CIF B18955765 (en adelante “El Organizador”),
                    llevará a cabo una actividad denominada “La energía de la Navidad”
                    (en adelante, “la actividad”) que se desarrollará de conformidad con lo
                    establecido en las presentes bases
                  </p>
                  <br />
                  <div>
                    <p><b>1.- EMPRESA ORGANIZADORA DE LAS PROMOCIONES</b></p>
                    <p>Grupo Empresarial Cuerva</p>
                    <p>B18955765</p>
                    <p>Calle Nueva de san Antón, 20 - PISO 5 A</p>
                    <p>Granada</p>
                    <p>18005</p>
                    <p>Granada</p>
                  </div>
                  <br />
                  <div>
                    <p><b>2.-FECHA DE INICIO Y FECHA DE FINALIZACIÓN</b></p>
                    <p>
                      Las bases de promoción se aplicarán a la actividad que empezará el
                      29 de noviembre y finalizará el día 18 de diciembre.
                      Los ganadores se anunciarán el 13 de enero.
                    </p>
                  </div>
                  <br />
                  <div>
                    <p><b>3.- REQUISITOS DE PARTICIPACIÓN</b></p>
                    <p>Los requisitos de participación serán los siguientes:</p>
                    <p>
                      Podrán participar aquellos alumnos de 3 y 4 curso de primaria de los
                      colegios ubicados en nuestra zona de distribución.
                    </p>
                  </div>
                  <br />
                  <div>
                    <p><b>4.- MECÁNICA DEL SORTEO Y CONDICIÓN DE LOS PREMIOS</b></p>
                    <p>
                      Los alumnos podrán participar en la actividad siguiendo una serie de pasos:
                      <br />
                      <li>
                        Coloreando el dibujo que han recibido previamente en el colegio
                      </li>
                      <li>
                        Completando la frase que aparece en el mismo
                      </li>
                    </p>
                    <p>
                      Una vez completado, el claustro del colegio determinará los 3 dibujos más
                      originales y creativos relacionados con la energía, de una clase de primaria,
                      teniendo en cuenta tanto el dibujo como la frase, y los hará llegar mediante
                      foto/escaneo a la dirección de&nbsp;
                      <a href="mailto:marketing@cuervaenergia.com"><u>marketing@cuervaenergia.com</u></a>
                      &nbsp;para determinar el ganador final.
                    </p>
                    <p>
                      Posteriormente cada alumno deberá mostrar el dibujo a sus padres para que
                      puedan escanear el código QR que aparece en el reverso de este, rellenar
                      las preguntas y enviar.
                    </p>
                    <br />
                    <p>
                      <b> Los premios serán:</b>
                      <br />
                      <p>
                        Bicicletas para repartir entre los ganadores en función del nº de colegios
                        participantes. A recoger en la oficina de Cuerva, situada en C. Sta. Lucía,
                        1, K, 18194 Churriana de la Vega, Granada.
                      </p>
                    </p>
                    <br />
                    <p>
                      El sorteo tiene una fecha límite para la participación indicada, que será
                      el día 18 de diciembre.
                    </p>
                    <br />
                    <p>
                      El 13 de enero será momento a partir del cual se llevará a cabo la
                      determinación de los ganadores. El/la ganador/a conoce y consiente que su
                      nombre completo y primer apellido sea publicado a través de la landing page
                      creada para el sorteo, en nuestras redes sociales junto con el certificado
                      de validez de este y contactado a través del colegio.
                    </p>
                    <br />
                    <p>
                      El resultado de los ganadores finales se realizará por nuestro equipo de
                      interno del departamento de distribución
                    </p>
                    <br />
                    <p>
                      De no reclamar el premio en el periodo de 20 días, el organizador comunicará
                      el premio a la persona suplente, el cual dispondrá del mismo periodo de 20
                      días para su reclamación, en caso de no comparecer, se declarará desierto.
                    </p>
                    <br />
                    <p>
                      Los premios son intransferibles. Se limita a un premio por persona.
                      El organizador se reserva el derecho a sustituir el premio por otro análogo
                      de mismo o superior valor en caso de fuerza mayor. En ningún caso se podrán
                      canjear los premios por su valor en metálico.
                    </p>
                  </div>
                  <br />
                  <div>
                    <p><b>5.- EXONERACIÓN DE RESPONSABILIDAD</b></p>
                    <p>
                      El ganador se responsabiliza de recaudar cualquier permiso o consentimiento
                      necesario para disfrute del premio y de cualquier incidente que se produzca
                      durante el mismo.
                    </p>
                    <br />
                    <p>
                      Los premios quedan sujetos a las presentes bases legales y no será posible
                      sustituirlos total o parcialmente por dinero en metálico
                    </p>
                    <br />
                    <p>
                      Los premios no serán susceptibles de cambio, alteración o compensación a
                      petición de los ganadores. Si se rechaza el premio, por parte del ganador,
                      no se le ofrecerá ningún alternativo. Queda estrictamente prohibida su venta
                      o enajenación.
                    </p>
                    <br />
                    <p>
                      Los participantes en la actividad se exoneran, de la forma más amplia que en
                      derecho proceda y sin limitar en modo sus derechos como consumidores, al
                      organizador, por cualquier tipo de responsabilidad, sanción, reclamación,
                      demanda o causa civil, mercantil, penal, administrativa, incluyendo
                      indemnizaciones de cualquier naturaleza y/o índole, gastos, costas (con
                      expresa inclusión de los honorarios de letrados y procuradores).
                    </p>
                    <br />
                    <p>
                      El participante acepta que el organizador pueda aplazar, acortar, prorrogar,
                      modificar, cancelar o suspender la actividad como consecuencia de causas de
                      fuerza mayor ajenas a su control, comprometiéndose a informar a los
                      participantes de esta circunstancia lo antes posible.
                    </p>
                    <br />
                    <p>
                      El organizador queda facultado para resolver cualquier contingencia no
                      prevista en las presentes bases legales.
                    </p>
                  </div>

                  <br />
                  <div>
                    <p><b>6.- CAMBIOS</b></p>
                    <p>
                      Nos reservamos el derecho de modificar o ampliar estas bases, en la medida
                      en que no perjudique o menoscabe los derechos de los participantes en la
                      actividad.
                      <br />
                      El simple hecho de participar en la misma implica la aceptación íntegra de
                      las presentes Bases. En caso de no ser aceptado el premio según consta en
                      estas Bases, se entendería que se renuncia al mismo.
                    </p>
                  </div>

                  <br />
                  <div>
                    <p><b>8.- LEGISLACIÓN APLICABLE Y JURISDICCIÓN</b></p>
                    <p>
                      Estas bases legales se regirán de conformidad con la ley española. Serán
                      competentes para resolver cualquier reclamación o controversia que pudiera
                      plantearse en relación con la validez, interpretación o cumplimiento de
                      estas bases los Juzgados y Tribunales de la ciudad de Granada.
                    </p>
                  </div>
                  <br />

                  <div>
                    <p><b>9.- CONSIDERACIONES FINALES</b></p>
                    <p>
                      La presente actividad tiene carácter gratuito para los participantes. Tanto
                      la actividad como los premios están sujetos a cambios o modificaciones.
                    </p>
                  </div>
                  <br />
                </div>
              )}
            />

          </div>
        </div>
        <br />
      </div>
    </PublicLayout>
  );
};
export default ChristmasContest;
